exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2e52021a]:export{navy:#001d38;turquoiseBlue:#00adbc;white:#fff;black:#000;error:#b71c1c;cancel:#f75b4a;success:#7ed321}.sub-headline[data-v-2e52021a]{font-family:Avenir-Heavy;font-size:16px}.page-booking-confirmation .page-section[data-v-2e52021a]{padding:2rem 0}@media screen and (min-width:1280px){.page-booking-confirmation .page-section[data-v-2e52021a]{padding:6.25rem 0}.page-booking-confirmation .page-section .grid-cards[data-v-2e52021a]{margin:2.5rem 0 3rem}}", ""]);

// exports
